import { takeLatest, put, call } from "redux-saga/effects";
import { handleApiError, isNotFoundError } from "@utils/errorHandler";

import {
  loadAllCompanies,
  loadSingleCompany,
  setSingleCompanyNotFound,
} from "./CompanyList.slice";

import { loadAllCompaniesAPI, loadSingleCompanyAPI } from "./CompanyList.api";

export const LOAD_ALL_COMPANIES = {
  LOADING: "Load all companies loading",
  SUCCESS: "Load all companies success",
  ERROR: "Load all companies error",
};

export const LOAD_SINGLE_COMPANY = {
  LOADING: "Load single company loading",
  SUCCESS: "Load single company success",
  ERROR: "Load single company error",
  NOT_FOUND: "Load single company not found",
};

function* loadAllCompaniesWorker(action) {
  const { payload } = action;

  try {
    const data = yield call(loadAllCompaniesAPI, payload);
    yield put(loadAllCompanies(data));
  } catch (error) {
    handleApiError(error);
    yield put({ type: LOAD_ALL_COMPANIES.ERROR, error });
  }
}

function* loadSingleCompanySagaWorker(action) {
  yield put(setSingleCompanyNotFound(false));
  const { payload } = action;

  try {
    const data = yield call(loadSingleCompanyAPI, payload);
    yield put(loadSingleCompany(data));
  } catch (error) {
    // handleApiError(error);
    // if (error?.response?.status === 404) {
    //   yield put({
    //     type: LOAD_SINGLE_COMPANY.NOT_FOUND,
    //   });
    //   return;
    // }
    if (isNotFoundError(error)) {
      yield put(setSingleCompanyNotFound(true));
      return;
    }
    handleApiError(error);
    yield put({ type: LOAD_SINGLE_COMPANY.ERROR, error });
  }
}

export function* loadAllCompaniesSaga() {
  yield takeLatest(LOAD_ALL_COMPANIES.LOADING, loadAllCompaniesWorker);
}

export function* loadSingleCompanySaga() {
  yield takeLatest(LOAD_SINGLE_COMPANY.LOADING, loadSingleCompanySagaWorker);
}
